import abLS from '@/business/abLocalStorage'
import setupApi from '@/apiFetch/setup/index'

var actions = {
  init({
    state,
    commit,
    dispatch,
    getters
  }) {
    // 用户刷新浏览器后，需要重新更新state
    if (!state.accessToken) {
      commit('setAccessToken', abLS.getAccessToken())
    }
    if (!state.userInfo.hasOwnProperty('userId')) {
      commit('setUserInfo', abLS.getUserInfo())
    }
    if (!state.userId) {
      commit('setUserId', abLS.getUserId())
    }
    dispatch('getPermissions')
  },
  getPermissions({ commit }) {
    if (abLS.getUserId() && abLS.getHotelId()) {
      setupApi.getPermissions({
        userId: abLS.getUserId(),
        hotelId: abLS.getHotelId()
      }).then((res) => {
        console.log(res)
        commit('setPermissions', res)
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
export default actions
